import React, { FC, PropsWithChildren } from 'react';

import EmptyState from '../EmptyState';

import { ReactComponent as EmptyStateGearIcon } from 'resources/img/svg/emptyStateGear.svg';

const GearResult: FC<PropsWithChildren> = ({ children }) => (
  <EmptyState icon={EmptyStateGearIcon} size="lg">
    {children}
  </EmptyState>
);

export default GearResult;
